import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollUpdateEmployeeCustomFieldsResponse, PayrollUpsertMode } from '../types';

// Schema: payrollUpdateEmployeeCustomFields(userId, fields, mode, effectiveFrom) returns PayrollEmployeeFields!
const updateMutation = gql`
  mutation PayrollUpdateEmployeeCustomFields($userId: ID!, $fields: JSON!, $mode: PayrollUpsertMode) {
    payrollUpdateEmployeeCustomFields(userId: $userId, fields: $fields, mode: $mode) {
      userId
      fields
    }
  }
`;

export const updateEmployeeCustomFields = (variables: {
  userId: string;
  fields: Record<string, unknown>;
  mode: PayrollUpsertMode;
}) =>
  graphQLApi<
    PayrollUpdateEmployeeCustomFieldsResponse,
    { userId: string; fields: Record<string, unknown>; mode: PayrollUpsertMode }
  >({
    query: updateMutation,
    queryVariables: variables,
  });
